// Config visual por TipoNotificacao (backend) — cada tipo novo adicionado no enum só precisa de
// uma entrada aqui para ganhar ícone/cor; sem isso cai no padrão (sino azul).
const CONFIG = {
    NOVA_TAREFA_USUARIO: { label: "Nova tarefa atribuída", cor: "azul", icone: "fa fa-bell" },
    NOVA_TAREFA_GRUPO: { label: "Nova tarefa para seu grupo", cor: "azul", icone: "fa fa-users" },
    SOLICITACAO_FINALIZADA: { label: "Solicitação finalizada", cor: "verde", icone: "fa fa-check-circle" },
    SOLICITACAO_CANCELADA: { label: "Solicitação cancelada", cor: "vermelho", icone: "fa fa-ban" },
};

const PADRAO = { label: "Notificação", cor: "azul", icone: "fa fa-bell" };

export function infoNotificacao(tipo) {
    return CONFIG[tipo] || PADRAO;
}
